import { render } from 'preact';
import { Boot } from '@shell/Boot';
import { ErrorBoundary } from '@shell/ErrorBoundary';
import { BootError } from '@shell/screens/BootError';
import '@/styles/index.css';

const root = document.getElementById('app');
if (!root) throw new Error('#app not found in index.html');

render(
  <ErrorBoundary fallback={() => <BootError />}>
    <Boot />
  </ErrorBoundary>,
  root,
);
